import { render, staticRenderFns } from "./designer_home.vue?vue&type=template&id=08fc4f4c"
import script from "./designer_home.vue?vue&type=script&lang=js"
export * from "./designer_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports